<ng-container *transloco="let t">
  <div
    class="p-dialog-with-toolbar common-lookup-dialog lookup-dialog-content"
    [ngClass]="lookupId"
    [formGroup]="form"
    (keydown.enter)="applyFilters()"
  >
    <div class="grid condensed-row">
      <div class="col-12 filters">
        <p-accordion>
          <p-accordionTab header="{{ t('consignee.consignee_lookup_dialog.tabs.filters') }}" [selected]="true">
            <!-- first row -->
            <div class="p-fluid grid condensed-row">
              <div class="field md:col-2 sm:col-6 col-12">
                <input
                  zTextInput
                  zAutoFocus
                  formControlName="consignee"
                  label="{{ t('consignee.consignee_lookup_dialog.filters.consignee') }}"
                  placeholder="{{ t('consignee.consignee_lookup_dialog.filters.consignee') }}"
                  styleClass="w-full"
                  [uppercase]="true"
                  [matchTypes]="true"
                  (matchTypeChange)="onMatchTypeChange('consignee', $event)"
                  defaultMatchType="startsWith"
                />
              </div>

              <div class="field md:col-2 sm:col-6 col-12">
                <input
                  zTextInput
                  formControlName="name"
                  label="{{ t('consignee.consignee_lookup_dialog.filters.name') }}"
                  placeholder="{{ t('consignee.consignee_lookup_dialog.filters.name') }}"
                  styleClass="w-full"
                  [uppercase]="true"
                  [matchTypes]="true"
                  (matchTypeChange)="onMatchTypeChange('name', $event)"
                  defaultMatchType="startsWith"
                />
              </div>

              <div class="field md:col-2 sm:col-6 col-12">
                <z-combo-box
                  [list]="stateOrProvinceList$ | async"
                  label="{{ t('consignee.consignee_lookup_dialog.filters.state_or_province') }}"
                  placeholder="{{ t('consignee.consignee_lookup_dialog.filters.state_or_province_select') }}"
                  fieldName="stateOrProvince"
                  [columnsConfig]="{ column1: { dropdown: { width: 60 } } }"
                >
                </z-combo-box>
              </div>

              <div class="field md:col-3 sm:col-6 col-12">
                <div class="p-fluid grid condensed-row">
                  <div
                    class="field md:col-6 col-12 z-checkbox-dual"
                    *ngIf="(consigneeService.customerConsigneeLookupDialogHideBillToShipToFilter$ | async) === false"
                  >
                    <div class="z-checkbox-dual-row">
                      <p-checkbox
                        inputId="filter-billTo"
                        formControlName="billTo"
                        label="{{ t('consignee.consignee_lookup_dialog.filters.bill_to') }}"
                        [binary]="true"
                        trueValue="Y"
                        falseValue="N"
                        styleClass="z-checkbox-small"
                      ></p-checkbox>
                    </div>

                    <div class="z-checkbox-dual-row">
                      <p-checkbox
                        inputId="filter-shipTo"
                        formControlName="shipTo"
                        label="{{ t('consignee.consignee_lookup_dialog.filters.ship_to') }}"
                        [binary]="true"
                        trueValue="Y"
                        falseValue="N"
                        styleClass="z-checkbox-small"
                      ></p-checkbox>
                    </div>
                  </div>

                  <div class="field md:col-6 col-12 z-checkbox-dual">
                    <div class="z-checkbox-dual-row">
                      <p-checkbox
                        inputId="filter-activeStatusOnly"
                        formControlName="activeStatusOnly"
                        label="{{ t('consignee.consignee_lookup_dialog.filters.active_status') }}"
                        [binary]="true"
                        trueValue="Y"
                        falseValue="N"
                        styleClass="z-checkbox-small"
                      ></p-checkbox>
                    </div>
                  </div>
                </div>
              </div>

              <div class="field md:col-3 sm:col-6 col-12 flex justify-content-end align-self-end">
                <button
                  pButton
                  type="button"
                  icon="fad fa-check"
                  label="{{ t('consignee.consignee_lookup_dialog.filters.apply_filters') }}"
                  class="p-button-outlined"
                  (click)="applyFilters()"
                  style="width: auto"
                ></button>

                <button
                  pButton
                  type="button"
                  icon="fad fa-undo-alt"
                  label="{{ t('consignee.consignee_lookup_dialog.filters.reset') }}"
                  class="p-button-secondary p-button-outlined ml-2"
                  (click)="reset()"
                  style="width: auto"
                ></button>
              </div>
            </div>
          </p-accordionTab>
        </p-accordion>
      </div>

      <div class="col-12 grid-table overflow-hidden">
        <z-customer-consignee-lookup-dialog-grid></z-customer-consignee-lookup-dialog-grid>
      </div>
    </div>

    <div class="p-dialog-footer p-dialog-footer-toolbar">
      <p-toolbar styleClass="dialog-toolbar" [formGroup]="form">
        <div class="p-toolbar-group-left">
          <z-legend type="form" [showHeader]="false">
            <z-legend-entry
              color="grey"
              label="{{ t('consignee.consignee_lookup_dialog.legend.inactive.label') }}"
              title="{{ t('consignee.consignee_lookup_dialog.legend.inactive.title') }}"
              styleClass="ml-1"
            ></z-legend-entry>
          </z-legend>
        </div>
        <div class="p-toolbar-group-right">
          <p-button
            label="{{ t('consignee.consignee_lookup_dialog.dialog.select') }}"
            styleClass="ml-1 p-button-primary"
            (click)="onSelectClick()"
          ></p-button>
          <p-button
            label="{{ t('consignee.consignee_lookup_dialog.dialog.cancel') }}"
            styleClass="ml-1 p-button-secondary"
            (click)="onCancelClick()"
          ></p-button>
        </div>
      </p-toolbar>
    </div>
  </div>
</ng-container>
